"use client";

import { DirectusImage } from "@/components/DirectusImage";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import { BadgeMinus, BadgePlus, CirclePlus, X } from "lucide-react";

import { PropsWithChildren, useEffect, useState } from "react";

export default function PreviewImage(
  props: PropsWithChildren<{
    image: string;
  }>
) {
  const [open, setOpen] = useState(false);

  const [scale, setScale] = useState(1);

  useEffect(() => {
    if (!open) {
      setScale(1);
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>{props.children}</DialogTrigger>

      <DialogContent className="h-screen w-screen max-w-none border-none shadow-none">
        <div
          className="relative h-full w-full transition-all duration-300"
          style={{ scale }}>
          <DirectusImage
            id={props.image}
            fill
            alt="Image"
            className="object-scale-down object-center"
          />
        </div>

        <div className="absolute left-1/2 top-[10%] flex -translate-x-1/2 items-center gap-10">
          <div
            className={cn(
              "cursor-pointer select-none text-white opacity-60 transition-all duration-300 hover:text-primary hover:opacity-100",
              {
                "pointer-events-auto cursor-not-allowed": scale === 1,
              }
            )}
            onClick={() => {
              // 图片缩小

              if (scale > 1) {
                setScale(scale - 1);
              }
            }}>
            <BadgeMinus size={30} />
          </div>
          <div
            className="cursor-pointer select-none text-white opacity-60 transition-all duration-300 hover:text-primary hover:opacity-100"
            onClick={() => {
              // 图片放大
              if (scale >= 3) {
                return;
              }

              setScale(scale + 1);
            }}>
            <BadgePlus size={30} />
          </div>
        </div>

        <div className="absolute right-[10%] top-[10%]">
          <DialogClose>
            <X
              size={30}
              className="text-white transition-colors duration-300 hover:text-primary"
            />
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
}
